export const styles = (theme) => {
  return {
    boxContainerTable: {
      borderRadius: '8px',
    },
    paperContainerTable: {
      width: '100%',
      borderRadius: '8px',
      boxShadow: theme.shadows[3],
    },
    removeBoxShadowContainerTable: {
      boxShadow: 'none',
    },
    tableContainerCashBankList: {
      height: 'calc(100vh - 260px)',
      minHeight: '275px',
      borderRadius: '8px',
    },
    iconButtonContainer: {
      '&:hover': {
        backgroundColor: 'rgba(222, 235, 255, 0.6)',
        '& svg': {
          fill: '#0052CC',
        },
      },
    },
    paid: {
      fontWeight: 500,
      color: '#027A48',
      backgroundColor: '#ECFDF3',
    },
    partially_paid: {
      fontWeight: 500,
      color: '#175CD3',
      backgroundColor: '#EFF8FF',
    },
  };
};
